import { RequestCatalogSearchServiceClient } from 'pbts/c1/api/requestcatalog/v1/requestcatalog.client'
import { RequestCatalogBundlesServiceClient } from 'pbts/c1/api/requestcatalog/v1/requestcatalogbundles.client'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'

export const searchRequestCatalogBundlesApi = createPagedListApi(
    RequestCatalogSearchServiceClient,
    'searchRequestCatalogBundles',
    undefined,
)

export const requestCatalogBundle = createMutationApi(
    RequestCatalogBundlesServiceClient,
    'requestBundle',
    undefined,
)
